import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom"; 
import AdminModal from "./adminModal";
import GetAPI from "../APICalls/GetAPI";
import "./adminTabs.css";

function AdminTabs({ children }) {
  const location = useLocation();
  const history = useHistory(); 
  const [verified, setVerified] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [checking, setChecking] = useState(true);

  const environment = process.env.REACT_APP_NODE_ENV;
  const userAPI =
    environment?.toUpperCase() === "PRODUCTION"
      ? process.env.REACT_APP_PROD_USERAPI
      : process.env.REACT_APP_DEV_USERAPI;

  useEffect(() => {
    const stored = localStorage.getItem("AdminDetails");

    if (!stored) {
      setVerified(false);
      setChecking(false);
      return;
    }

    const parsed = JSON.parse(stored);
    const completeUserURL = `${userAPI}?userMobile=${parsed.userMobile?.replace(
      "+",
      ""
    )}`;

    GetAPI(completeUserURL)
      .then((res) => {
        if (
          res.data?.statusCode === 200 &&
          Object.keys(res.data.body).length > 0
        ) {
          const serverUser = res.data.body;
          setAdminData(serverUser);

          if (serverUser.isAdmin?.toUpperCase() === "TRUE") {
            setVerified(true);
          } else if (
            serverUser.isAdmin?.toUpperCase() === "FALSE" &&
            serverUser.adminType === "QSR_MANAGER"
          ) {
            setVerified(true);
          } else {
            setVerified(false);
          }
        } else {
          setVerified(false);
        }
      })
      .catch(() => setVerified(false))
      .finally(() => setChecking(false));
  }, [userAPI]);

  useEffect(() => {
    if (!checking && verified && adminData) {
      const isQSRManager =
        adminData.isAdmin?.toUpperCase() === "FALSE" &&
        adminData.adminType?.toUpperCase() === "QSR_MANAGER";

      if (isQSRManager) {
        const allowedPaths = ["/qsr"];
        if (!allowedPaths.includes(location.pathname)) {
          history.replace("/qsr"); 
        }
      }
    }
  }, [checking, verified, adminData, location.pathname, history]);

  const handleVerified = () => {
    setVerified(true);
  };

  const navItems = [
    { label: "Orders", path: "/orderStatus" },
    { label: "Xpress Orders", path: "/xpress" },
    { label: "Subscriptions", path: "/sub" },
    { label: "Initiate Customer Chat", path: "/chat" },
    { label: "QSR Vendor Portal", path: "/qsr" },
    { label: "Metrics", path: "/metrics" },
    { label: "Finance", path: "/finance" },
    { label: "Corporate Onboarding", path: "/corporateOnboarding" },
    { label: "Corporate Leads", path: "/corporateLeads" },
    { label: "Chef Verification", path: "/chefVerification" },
    { label: "Referral", path: "/referralGenerate" },
    { label: "Push Notification", path: "/pushNotification" },
    { label: "Wallet", path: "/wallet" },
  ];

  let visibleTabs = navItems;
  if (
    adminData?.isAdmin?.toUpperCase() === "FALSE" &&
    adminData?.adminType?.toUpperCase() === "QSR_MANAGER"
  ) {
    visibleTabs = navItems.filter((item) => item.label?.toLowerCase() === "qsr vendor portal");
  }

  if (checking) {
    return <div className="p-5 text-center">Checking admin access...</div>;
  }

  if (!verified) {
    return <AdminModal handleVerified={handleVerified} />;
  }

  return (
    <div className="adminTab">
      <div className="row row-section adminTab">
        <nav className="navbar navbar-expand-lg navbar-light bg-light py-0 px-3">
          <a className="navbar-brand" href="/admin">
            Admin
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="navbar-collapse show" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              {visibleTabs.map(({ label, path }) => (
                <li className="nav-item" key={path}>
                  <a
                    className={`nav-link ${
                      location.pathname === path ? "font-weight-bold" : ""
                    }`}
                    href={path}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
      <div className="mt-3">{children}</div>
    </div>
  );
}

export default AdminTabs;
